"use client"

import React from "react"
import menuData from "../Header/menuData"
import Lucide from "@/base-components/Lucide"
import clsx from "clsx"
import { useDictionary } from "@/libs/DictionaryProvider"
import HoverComponent from "./HoverComponent"
import Link from "next/link"
import { usePathname } from "next/navigation"

const ClosedSideBar = ({ lang }) => {
  const { navigation } = useDictionary()
  const pathUrl = usePathname()

  return (
    <div className="flex text-xs flex-col h-full   gap-4 items-left pt-5 w-full px-4 !overflow-y-scroll  no-scrollbar !overflow-x-hidden">
      {menuData.map((menuItem, key) => (
        <div key={key}>
          {!menuItem.submenu ? (
            <Link
              prefetch={menuItem.path === "tools/trade" ? false : true}
              href={`/${lang}/${menuItem.path}`}
              data-onboarding={
                menuItem.path.includes("tools/tracker")
                  ? "tracker-nav"
                  : undefined
              }
              className={`w-full `}
              key={key}
            >
              <div
                className={`flex flex-col items-center w-full text-white font-semibold p-2 cursor-pointer rounded-lg  hover:bg-white/5  ${
                  pathUrl.includes(menuItem.path)
                    ? "nav-gradient-closed text-white"
                    : "text-white/80"
                }`}
              >
                <span className="flex text-center justify-center items-center">
                  <Lucide className="mr-0 " icon={menuItem.icon} />
                </span>
                <span className={clsx("block transition-all delay-100 mt-1")}>
                  {menuItem.titleClosed}
                </span>
              </div>
            </Link>
          ) : (
            <HoverComponent lang={lang} menuItem={menuItem} />
          )}
        </div>
      ))}
    </div>
  )
}

export default ClosedSideBar
